/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { Box, VStack, Flex } from 'chakra-v3';
import { useNavigate } from 'react-router-dom';
import { Text } from '../components/Text';
import { Button } from '../components/buttons/Index';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    void navigate('/');
  };

  return (
    <Box minH="100vh" bg="bg.primary">
      <Flex minH="100vh" alignItems="center" justifyContent="center" px={{ base: 4, md: 6 }} py={{ base: 16, md: 20 }}>
        <VStack gap={{ base: 8, md: '24px' }} align="center" textAlign="center" w="100%">
          <Text variant="heroHeading" fontSize={{ base: '48px', md: '64px', lg: '80px' }}>
            Page Not Found
          </Text>
          <Text variant="heroSubheading" fontSize={{ base: '20px', md: '24px' }}>
            Error code: 404
          </Text>
          <Text variant="heroSubheading">The page you are looking for does not exist.</Text>
          <Button variant="secondary" onClick={handleGoHome}>
            Go to Homepage
          </Button>
        </VStack>
      </Flex>
    </Box>
  );
};

export default NotFound;
